"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestManager = void 0;
var constants_1 = require("./constants");
var RequestManager = /** @class */ (function () {
    function RequestManager() {
        var _this = this;
        this.messageQueue = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.isExtensionEvent = function (data) {
            return ((data === null || data === void 0 ? void 0 : data.source) === "react-devtools-bridge" ||
                (data === null || data === void 0 ? void 0 : data.source) === "react-devtools-content-script" ||
                (data === null || data === void 0 ? void 0 : data.source) === "react-devtools-detector" ||
                (data === null || data === void 0 ? void 0 : data.type) === "webpackOk" ||
                typeof data.messageId !== "string" ||
                data.source !== "WEBB_EXTENSION");
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleEvent = function (event) {
            if (_this.isExtensionEvent(event.data))
                return;
            var _a = event.data, messageId = _a.messageId, data = _a.data, error = _a.error;
            var messageResolver = _this.messageQueue[messageId];
            if (!messageResolver)
                return;
            var timeout = messageResolver.timeout, resolve = messageResolver.resolve, reject = messageResolver.reject;
            if (error) {
                reject(error);
            }
            else {
                resolve({ data: data });
            }
            delete _this.messageQueue[messageId];
            if (timeout)
                clearTimeout(timeout);
        };
        this.newMessage = function (message) {
            var messageId = message.command + (Date.now() + Math.random()).toString();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var reject = message.reject, resolve = message.resolve, timeout = message.timeout, rest = __rest(message, ["reject", "resolve", "timeout"]);
            try {
                window.postMessage(__assign(__assign({}, rest), { messageId: messageId, source: "WEBB", timout: timeout &&
                        setTimeout(function () {
                            console.log("message timed out", messageId);
                            delete _this.messageQueue[messageId];
                            reject(constants_1.ERRORS.REQUEST_TIMEOUT);
                        }, timeout) }), "*");
            }
            catch (error) {
                reject(constants_1.ERRORS.SEND_INTERNAL);
                return;
            }
            _this.messageQueue[messageId] = message;
        };
        try {
            window.addEventListener("message", this.handleEvent, false);
        }
        catch (error) {
            console.log("error adding event listener");
        }
    }
    return RequestManager;
}());
exports.RequestManager = RequestManager;
exports.default = new RequestManager();
//# sourceMappingURL=requestManager.js.map